<template>
  <div>

    <Row style="border-left: 5px solid #009688;margin-bottom: 5px">
      <Col span="3">订单数量: <Tag color="error">{{countData.order_num}}</Tag></Col>
      <Col span="3">消费总额: <Tag color="error">{{countData.total_price}} 元</Tag></Col>
      <Col span="3">加油升数: <Tag color="error">{{countData.total_litre}} 升</Tag></Col>
    </Row>

    <pageTable ref="table"
               :tableTitle="tableColumn"
               :searchData="searchData"
               :doneFunction="doneFunction"
               tableApi="admin/my_company/orders"
    >
      <template v-slot:searchFormItem>
        <FormItem prop="mobile">
          <Input type="text" v-model="searchData.mobile" placeholder="手机" class="lx-search-item"></Input>
        </FormItem>
        <FormItem prop="user_name">
          <Input type="text" v-model="searchData.user_name" placeholder="司机姓名" class="lx-search-item"></Input>
        </FormItem>
        <FormItem prop="car_number">
          <Input type="text" v-model="searchData.car_number" placeholder="车牌" class="lx-search-item"></Input>
        </FormItem>
        <FormItem prop="gas_name">
          <Input type="text" v-model="searchData.gas_name" placeholder="油站名称" class="lx-search-item"></Input>
        </FormItem>
        <FormItem prop="create_time">
          <DatePicker v-model="searchData.create_time" type="datetimerange" @on-change="timeChange" placeholder="消费时间" style="width: 320px"></DatePicker>
        </FormItem>
      </template>

      <template v-slot:otherBtn>
          <Button type="info" @click="download">下载</Button>
      </template>
    </pageTable>

  </div>
</template>

<script>
  import pageTable from "@/components/table/pageTable";
  import XLSX from 'xlsx'

  export default {
    name: "lists",
    components:{pageTable},
    data() {
      return {
        editUserId:0,     //编辑的ID
        showUserDetail:false,
        editOrderId:0,     //编辑的ID
        showOrderDetail:false,
        searchData: {
          mobile: '',
          create_time:'',
          user_name:'',
          gas_name:'',
          type_id:'',
          car_number:'',
        },
        tableColumn: [
          {title: '司机',key: 'mobile',align: "center"},
          {title: '姓名',key: 'user_name',align: "center"},
           {title: '订单号',key: 'order_no',align: "center"},
          {title: '车牌',key: 'car_number',align: "center",render:(h,params)=>{
            return h('a',{
              on:{
                click:()=>{
                  this.changeCarNumber(params.row.order_id)
                }
              }
            },params.row.car_number)
            }},
          {title:'油站',key:'gas_name',align:'center'},
          {title:'站点类型',key:'station_type_name',align:'center'},
          {title:'凭证',key:'proof',align:'left',render:(h,params)=>{
            if (params.row.proof_car===''){
              return h('span','未上传');
            }else{
              let content = [];
              if (params.row.proof_car !== ''){
                content.push(h('img',{
                  attrs:{src:params.row.proof_car},
                  style:{width:'60px',height:'60px'
                  },
                  on:{click:()=>{this.showProof(params.row)}}
                }))
              }
              if (params.row.proof_station !== ''){
                content.push(h('img',{
                  attrs:{src:params.row.proof_station},
                  style:{width:'60px',height:'60px'
                  },
                  on:{click:()=>{this.showProof(params.row)}}
                }))
              }
              if (params.row.proof_mileage !== ''){
                content.push(h('img',{
                  attrs:{src:params.row.proof_mileage},
                  style:{width:'60px',height:'60px'
                  },
                  on:{click:()=>{this.showProof(params.row)}}
                }))
              }
               return h('div',content)
            }
            }},
          {
            title: '消费金额', 
            key: 'total_price', 
            align: 'center', 
            width: 200,
            render: (h, params) => {
              if (params.row.sub_orders && params.row.sub_orders.length > 0) {
                let content = [];
                params.row.sub_orders.forEach((subOrder) => {
                  const companyName = this.getSubOrderCompanyName(subOrder);
                  content.push(h('div', `主体: ${companyName}, 扣款: ${subOrder.actualPayAmount}元`));
                });
                content.push(h('div', `总金额: ${params.row.total_price}元`));
                return h('div', content);
              } else {
                return h('div', `总金额: ${params.row.total_price}元`);
              }
            }
          },
          {title:'数量(升)',key:'litre_num',align:'center'},
          { 
            title: '价格', 
            key: 'company_price', 
            align: 'center',
            render: (h, params) => {
              return h('div', [
                h('div', `单价:${params.row.company_price}`),
                // h('div', `挂牌价：${params.row.station_price}`)
              ])
            }
          },
          {title:'起止公里',key:'company_price',align:'left',render:(h,params)=>{
              return h('div',[
                h('p',`${params.row.prev_mileage} / ${params.row.mileage}`),
              ])
            }},
          {title:'油耗',key:'fuel_economy',align:'left'},
          {title:'下单时间',key:'create_time',align:'center',width:180},
          {title:'状态',align:'center',key:'status_name'},
        ],
        tableData: [],
        countData:{},
        stations:[],
        companyNameMap:{},
        changeNumber:'',
      }
    },
    methods: {
      getSubOrderCompanyName(subOrder){
        const companyId = subOrder.company_id || subOrder.enterpriseNo || '';
        if (subOrder.company_name) return subOrder.company_name;
        if (subOrder.companyName) return subOrder.companyName;
        if (companyId !== '' && this.companyNameMap[companyId]) return this.companyNameMap[companyId];
        return companyId !== '' ? `车队ID:${companyId}` : '未知车队';
      },
      loadCompanyNameMap(){
        this.$commonFun.postProxy('admin/common/getPageInitInfo',{type:['companys']}).then((res)=>{
          if (!res || !res.data || !res.data.companys) return;
          const map = {};
          res.data.companys.forEach((item)=>{
            if (item.id !== undefined && item.id !== null) map[item.id] = item.name;
            if (item.company_id !== undefined && item.company_id !== null) map[item.company_id] = item.name;
          });
          this.companyNameMap = map;
        })
      },
      showDetail(order_id){
        this.editOrderId = order_id
        this.showOrderDetail = true
      },
      showUserDetailPage(user_id){
        this.showUserDetail = true
        this.editUserId = user_id
      },
      reloadDetail(user_id){
        this.showUserDetail = false
        this.$nextTick(()=>{
          this.showUserDetailPage(user_id)
        })
      },
      doneFunction(res){
        this.countData = res.extra
      },
      showProof(info){
        let images = [];
        if (info.proof_car !== '') images.push(info.proof_car);
        if (info.proof_station !== '') images.push(info.proof_station);
        if (info.proof_mileage !== '') images.push(info.proof_mileage);
        this.$viewerApi({
          images: images,
          options: {
            initialViewIndex: 0,
          },
        })
      },
      download(){
        this.$commonFun.postProxy('admin/my_company/exportOrders',this.searchData).then(res=>{
          this.$commonFun.dealApiResult(res,()=>{
            let worksheet = XLSX.utils.aoa_to_sheet(res.data)
            let workbook = XLSX.utils.book_new()
            XLSX.utils.book_append_sheet(workbook,worksheet,'sheet1')
            XLSX.writeFile(workbook,`消费记录.xlsx`)
          })
        })
      },
      changeCarNumber(order_id){
        this.$Modal.confirm({
          title:'更换车牌',
          render:(h)=>{
            return h( 'Input', {
              size: "large",
              modelValue: this.changeNumber,
              autofocus: true,
              placeholder: '请输入退款原因',
              on:{
                input:(val)=>{
                  this.changeNumber = val;
                }
              }
            })
          },
          loading:true,
          onOk: async ()=>{
            let res = await this.$commonFun.postProxy('admin/order/changeCarNumber',{order_id,changeNumber:this.changeNumber});
            this.$Modal.remove()
            this.$commonFun.dealApiResult(res,()=>{
              this.$commonFun.successTip(res.msg)
              this.$refs.table.getLists();
            })
          }
        })
      },
      timeChange(time) {
        if (time && time[1] && time[1].slice(-8) === '00:00:00') {
          time[1] = time[1].slice(0, -8) + '23:59:59';
        }
        this.searchData.create_time = time;
      },
    },
    mounted() {
      this.loadCompanyNameMap();
    },
  }
</script>

<style scoped>

</style>
